import { Employee, Permission } from '../types';
import { useFetchData } from "../../../hooks/useFetch";
import { API_PRIVILEGE_ROUTER, ApiConfig, API_USER_ROUTER } from "../../../services/api-config";

export interface EmployeeListResponse {
  list: Employee[];
  total_record?: number;
  limit?: number;
}

export interface PrivilegeListResponse {
  list: Permission[];
  total_record?: number;
  limit?: number;
}

export interface EmployeeListFilters {
  status?: number; // 1 active, 0 inactive, -1 all
  keyword?: string;
  key_search?: string;
  department_id?: number;
  page?: number;
  limit?: number;
}

export interface PrivilegeListFilters {
  status?: number;           // 1 active, 0 inactive, -1 all
  keyword?: string;
}

export interface EmployeePermissionResponse {
  group: number;
  privileges: number[];
}

export interface UpdatePermissionPayload {
  privilege_ids: number[];
}

export interface UpdatePermissionEmployeeResponse{
  massage: string;
}

export const permissionEmployeeService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<EmployeeListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: EmployeeListFilters = { status: 1 }) =>
        request({
          endPoint: API_USER_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  listPermission: () => {
    const { request, baseResponse, loading } = useFetchData.Get<PrivilegeListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: PrivilegeListFilters = { status: 1 }) =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  getPermissionsForEmployee: () => {
      const { request, baseResponse, loading } = useFetchData.Get<EmployeePermissionResponse[]>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return {
        fetch: (id: number) =>
          request({
            endPoint: API_USER_ROUTER.API_PRIVILEGE(id),
          }),
        response: baseResponse,
        loading: loading,
      }
    },
  updatePermissionsForEmployee: () => {
    const { request, baseResponse, loading } = useFetchData.Post<UpdatePermissionEmployeeResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return{
      fetch: (id: number, payload: UpdatePermissionPayload) =>
        request({
          endPoint: API_USER_ROUTER.API_UPDATE_PRIVILEGE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading
    }
  }

}
